<div class="tmp-page">

  <!-- Header -->
  <header class="tmp-page__header">
    <div class="tmp-page__header-left">
      <div class="tmp-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M4 4h6v6H4z"/>
          <path d="M14 4h6v6h-6z"/>
          <path d="M4 14h6v6H4z"/>
          <path d="M17 14v6M14 17h6"/>
        </svg>
      </div>
      <div>
        <h1 class="tmp-page__title">Types de mode de passation</h1>
        <p class="tmp-page__desc">Gérez les types de mode de passation de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter un type"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      (clicked)="openTypeModePassationModal()"
    ></app-ui-button>
  </header>

  <!-- Card / Table -->
  <div class="tmp-card">
    @if (isLoading) {
      <div class="tmp-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="tmp-card__toolbar">
        <div class="tmp-card__toolbar-left">
          <span class="tmp-badge">{{ typeModePassations.length }}</span>
          <span class="tmp-card__count">
            enregistrement{{ typeModePassations.length > 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      @if (!typeModePassations.length) {
        <div class="tmp-empty">
          <div class="tmp-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M4 4h6v6H4z"/>
              <path d="M14 4h6v6h-6z"/>
              <path d="M4 14h6v6H4z"/>
              <path d="M17 14v6M14 17h6"/>
            </svg>
          </div>
          <p class="tmp-empty__title">Aucun type de mode de passation</p>
          <p class="tmp-empty__hint">Commencez par en ajouter un en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table
          [columns]="tableTypeModePassation"
          [data]="typeModePassations"
          [actions]="rowActions"
        />
      }
    }
  </div>

  <!-- Row actions template -->
  <ng-template #rowActions let-item="item">
    <div class="tmp-row-actions">
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        (clicked)="onEditTask(item)"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>

</div>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.libelle || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>

<!-- Modal Ajout / Édition -->
<app-modal
  [isVisible]="showAddTypeModePassationModal"
  [title]="isEditing ? 'Modifier le type' : 'Nouveau type de mode de passation'"
  (closeEvent)="closeTypeModePassationModal()"
>
  <form [formGroup]="typeModePassationForm" (ngSubmit)="saveTypeModePassation()" class="tmp-form">

    @if (isEditing && editingTypeModePassation) {
      <div class="tmp-edit-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Modification de <strong>{{ editingTypeModePassation.libelle }}</strong>
      </div>
    }

    <div class="tmp-form__field">
      <app-input
        label="Type de mode de passation"
        placeholder="Ex : Appel d'offres"
        type="text"
        formControlName="libelle"
      />
      @if (typeModePassationForm.get('libelle')?.invalid && (typeModePassationForm.get('libelle')?.dirty || typeModePassationForm.get('libelle')?.touched)) {
        <span class="tmp-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Le libellé est requis.
        </span>
      }
    </div>

    <div class="tmp-form__actions">
      <app-ui-button
        label="Annuler"
        variant="ghost"
        size="md"
        type="button"
        (clicked)="closeTypeModePassationModal()"
      ></app-ui-button>
      <app-ui-button
        [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'"
        variant="primary"
        size="md"
        [iconLeft]="isEditing ? 'check' : 'save'"
        type="submit"
        [loading]="isLoading"
        [disabled]="isLoading || typeModePassationForm.invalid"
      ></app-ui-button>
    </div>

  </form>
</app-modal>